import BaseModal from 'components/Modals/BaseModal';
import USGSDeviceSettings from 'features/Integrations/features/ConnectedDevices/components/USGSDeviceSettings/USGSDeviceSettings';
import { Device } from 'features/Integrations/features/ConnectedDevices/types/MonitoringStation_types';

type Props = {
  usgsOpen: boolean;
  usgsDevice: Device | null;
  onSetUSGSOpen: (v: boolean) => void;
};

export default function USGSModal({ usgsOpen, usgsDevice, onSetUSGSOpen }: Props) {
  return (
    <>
      <BaseModal
        show={usgsOpen}
        handleShow={() => onSetUSGSOpen(false)}
        title={
          usgsDevice
            ? `${usgsDevice.alias || 'USGS Monitoring Station'} (${usgsDevice.node_id})`
            : 'USGS Settings'
        }
      >
        <USGSDeviceSettings onClose={() => onSetUSGSOpen(false)} />
      </BaseModal>
    </>
  );
}